import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CoconutCustomizer from './components/CoconutCustomizer';
import Products from './components/Products';
import EventTypes from './components/EventTypes';
import Stats from './components/Stats';
import VideoSection from './components/VideoSection';
import Services from './components/Services';
import Celebrities from './components/Celebrities';
import Plans from './components/Plans';
import Cities from './components/Cities';
import Occasions from './components/Occasions';
import WhyChoose from './components/WhyChoose';
import Testimonials from './components/Testimonials';
import Partners from './components/Partners';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import EnquiryModal from './components/EnquiryModal';
import { Toaster } from './components/ui/toaster';
import { QuoteProvider } from './context/QuoteContext';
import { AuthProvider } from './context/AuthContext';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminOrders from './pages/AdminOrders';
import ProductPage from './pages/ProductPage';
import ProductsIndex from './pages/ProductsIndex';
import AdminProductImages from './pages/AdminProductImages';

const HomePage = () => {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <CoconutCustomizer />
        <Products />
        <EventTypes />
        <Stats />
        <VideoSection />
        <Services />
        <Celebrities />
        <Plans />
        <Cities />
        <Occasions />
        <WhyChoose />
        <CTA />
        <Testimonials />
        <Partners />
        <FAQ />
      </main>
      <Footer />
      <FloatingButtons />
      <EnquiryModal />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <QuoteProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/product-images" element={<AdminProductImages />} />
              <Route path="/products" element={<ProductsIndex />} />
              <Route path="/products/:slug" element={<ProductPage />} />
            </Routes>
          </QuoteProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
